export default __webpack_public_path__ + "static/jhdixon-2019-06-29-fuji-gilgandra-4435-31ae944953a9b7d92faab84049589b25.jpg";